import { Injectable } from '@angular/core';
import { FormGroup, AbstractControl, FormArray } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import * as _ from 'lodash';
import { MonoTypeOperatorFunction, Observable, defer, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FormErrorService {

  private arrayRegex = /(\w+)\[(\d+)\]/;

  constructor() { }

  public applyErrorResponses<T>(formGroup: FormGroup): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>) => defer(() => {
      return source.pipe(
        catchError((error: HttpErrorResponse) => {
          this.applyErrorToForm(formGroup, error);
          return throwError(error);
        })
      );
    });
  }

  private applyErrorToForm(formGroup: FormGroup, error: HttpErrorResponse): any {
    if (error && error.error && error.error.length > 0) {
      error.error.forEach(err => {
        if (!err.propertyName || !err.errorMessage) {
          return;
        }

        const { control, propertyName } = this.getControlFromProperty(err.propertyName, formGroup, '');

        if (!!control && !!propertyName) {
          control.setErrors({ error: propertyName, errorMessage: err.errorMessage });
        }
      });

      formGroup.updateValueAndValidity();
    }
  }

  /**
   * Find control given `Targets[0].ReasonsFor[0].EvidenceId`
   */
  getControlFromProperty(propertyName: string, control: AbstractControl, childPropertyKey: string)
    : { control: AbstractControl, propertyName: string } {
    const propertyIsDottedProperty = propertyName.includes('.');
    const propertyIsArrayIndex = propertyName.includes('[');

    if (propertyIsDottedProperty) {
      const parentProperty = propertyName.substring(0, propertyName.indexOf('.'));
      const childProperty = propertyName.substring(propertyName.indexOf('.') + 1);
      return this.getControlFromProperty(parentProperty, control, childProperty);
    }

    if (propertyIsArrayIndex) {
      const bits = propertyName.match(this.arrayRegex);
      if (bits.length === 3) {
        propertyName = _.camelCase(bits[1]);
        const index = bits[2];
        control = ((control as FormGroup).controls[propertyName] as FormArray).controls[index];
        return this.getControlFromProperty(childPropertyKey, control, '');
      }
    }

    propertyName = _.camelCase(propertyName);

    if (!!childPropertyKey) {
      return this.getControlFromProperty(childPropertyKey, control, '');
    } else {
      control = (control as FormGroup).controls[propertyName];
    }

    return { control, propertyName };
  }
}
